export const LINE_VIEW_TYPES = {
  TABLE: 'table',
  BUTTON: 'button'
};

export const REDIRECT_ACTIONS = {
  SET: 'setRedirectAction',
  GET: 'getRedirectAction',
  APPLY: 'applyRedirectAction'
};

export const REDIRECT_PARAM = 'redirectUrl=';

// TODO use values from sports package from SPORT_IDS instead of VERMANTIA_SPORT_ID and BONUS_SPORT_ID
export const VERMANTIA_SPORT_ID = 179;

export const DEFAULT_PAGE_SIZE = 10;

export const FILTER_ALL_VALUE = 'all';

export const DATE_FILTER = [
  {
    value: '2',
    label: 'personalOffice.filter.options.date.todayYesterday'
  },
  {
    value: '7',
    label: 'personalOffice.filter.options.date.for7days'
  },
  {
    value: '30',
    label: 'personalOffice.filter.options.date.for30days'
  },
  {
    value: '90',
    label: 'personalOffice.filter.options.date.for90days'
  }
];

export const DATES_OPTION_FILTER = [
  {
    value: '2',
    label: 'web.balance.deposithistory.filter.daterange_1'
  },
  {
    value: '7',
    label: 'web.balance.deposithistory.filter.daterange_7'
  },
  {
    value: '30',
    label: 'web.balance.deposithistory.filter.daterange_30'
  },
  {
    value: '90',
    label: 'web.balance.deposithistory.filter.daterange_90'
  }
];

export const DATE_RANGE_FILTER_VALUE = 'dtRange';

export const TRANSACTIONS_STATUS_FILTER = [
  {
    value: FILTER_ALL_VALUE,
    label: 'web.balance.deposithistory.filter_all'
  },
  {
    value: 'pending',
    label: 'web.balance.deposithistory.filter.state_1'
  },
  {
    value: 'canceled',
    label: 'web.balance.deposithistory.filter.state_3'
  },
  {
    value: 'completed',
    label: 'web.balance.deposithistory.filter.state_2'
  }
];

export const PURCHASE_STATUS_FILTER = [
  {
    value: FILTER_ALL_VALUE,
    label: 'personalOffice.filter.options.purchaseHistory.status.all'
  },
  {
    value: 'pending',
    label: 'personalOffice.filter.options.purchaseHistory.status.pending'
  },
  {
    value: 'canceled',
    label: 'personalOffice.filter.options.purchaseHistory.status.canceled'
  },
  {
    value: 'completed',
    label: 'personalOffice.filter.options.purchaseHistory.status.completed'
  }
];

export const STEP_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error'
};

export const LINK_TYPE_RAW = 'raw';

export const HEADER_HEIGHT = 48;
export const DESKTOP_HEADER_HEIGHT = 60;

export const BOTTOM_NAV_MENU_HEIGHT = 56;

export const STREAM_PLAYER_TYPE = {
  PLAYER: 'PLAYER',
  IFRAME: 'IFRAME'
};

export const STREAM_TYPE = {
  BROADCAST: 'BROADCAST',
  TWITCH: 'TWITCH',
  FAVTV: 'FAVTV'
};

export const PROVIDER_HEADER_TYPE = {
  SMARTICO: 'smartico'
};
